module.exports = __webpack_public_path__ + "static/img/xuefenlogo.e8c9d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xuefenlogo.png
// module id = ENUf
// module chunks = 1